import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Single shared store + one poll loop for the whole app. Every map/page that
// calls useLiveVehicles() subscribes to the SAME live fleet data (one backend
// endpoint, one cache) — no duplicate Quartix calls, same vehicleId everywhere.
let store = {
  vehicles: [], enabled: true, loading: false, error: null,
  fetchedAt: null, available: true,
};
const subs = new Set();
let timer = null;
const POLL_MS = 15000;

const emit = () => subs.forEach((fn) => fn(store));
const set = (patch) => { store = { ...store, ...patch }; emit(); };

async function poll() {
  if (!store.enabled) return;
  set({ loading: true });
  try {
    const r = await api.get("/quartix/vehicles/live");
    if (r.data && r.data.enabled === false) {
      set({ loading: false, available: false, vehicles: [] });
    } else {
      set({
        loading: false, available: true, error: r.data?.error || null,
        vehicles: r.data?.vehicles || [], fetchedAt: r.data?.fetched_at || null,
      });
    }
  } catch (e) {
    set({ loading: false, error: "unavailable" });
  }
}

function ensureLoop() {
  if (timer) return;
  poll();
  timer = setInterval(poll, POLL_MS);
}

export function setLiveVehiclesEnabled(v) {
  set({ enabled: v });
  if (v) { ensureLoop(); poll(); }
}

export function useLiveVehicles() {
  const [s, setS] = useState(store);
  useEffect(() => {
    subs.add(setS);
    ensureLoop();
    return () => {
      subs.delete(setS);
      if (subs.size === 0 && timer) { clearInterval(timer); timer = null; }
    };
  }, []);
  return { ...s, setEnabled: setLiveVehiclesEnabled, refresh: poll };
}
